// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#yourshop .product-search-wrap .icon10, #yourshop .product-search-wrap .icon16 { display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
